import { Card, CardContent, Grid, Paper, Typography } from '@mui/material';

import CraftLogo from './icons/CraftLogo';

const Homepage = () => (
  <Card sx={{ padding: 8 }}>
    <Grid container justifyContent="center">
      <Paper elevation={2} sx={{ py: 4, px: 8 }}>
        <CraftLogo width="80" />
      </Paper>
    </Grid>
    <CardContent sx={{ mt: 4, textAlign: 'center' }}>
      <Paper elevation={2} sx={{ p: 8 }}>
        <Typography variant="h4">Welcome to Craft Admin</Typography>
        <Typography variant="body1" mt={4} fontWeight="bold" fontSize="1.1em">
          Good luck. And don&apos;t break anything 😈
        </Typography>
      </Paper>
    </CardContent>
  </Card>
);

export default Homepage;
